// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dataInfoRoot[data-v-59b6f5b2],.fullContainer[data-v-59b6f5b2]{height:100%}.resourceFormPage__lead[data-v-59b6f5b2]{display:flex;align-items:center;flex-wrap:wrap;gap:8px 16px;min-width:0;flex:1}.resourceFormPage__actions .resourceFormPage__btn[data-v-59b6f5b2]{box-sizing:border-box;min-width:104px;padding-left:16px;padding-right:16px}", ""]);
// Exports
module.exports = exports;
